import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useParallax } from "@/lib/useParallax";
import AnnouncementBar from "@/components/landing/AnnouncementBar";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";

/**
 * Shared marketing shell:
 *   AnnouncementBar + Navbar + <children/> + Footer
 *
 * Also redirects authenticated users into the app so signed-in visitors don't
 * see the marketing site.
 */
export default function MarketingLayout({ children, redirectAuthed = true }) {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  useParallax();

  useEffect(() => {
    if (!redirectAuthed) return;
    if (!loading && user) {
      navigate("/app/find-customers", { replace: true });
    }
  }, [user, loading, navigate, redirectAuthed]);

  useEffect(() => {
    // Ensure marketing pages open at the top when navigated into
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in document.documentElement.style ? "instant" : "auto" });
  }, []);

  return (
    <div className="min-h-screen bg-lm-bg text-lm-text overflow-x-hidden flex flex-col">
      <AnnouncementBar />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
